import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";

const initialState = localStorage.getItem("categoryWordResult")
  ? JSON.parse(localStorage.getItem("categoryWordResult"))
  : {
      categoryWordResult: null,
    };

const secretKey = "my little secret";

export const decryptData = (encryptedData) => {
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(
    CryptoJS.enc.Utf8
  );
  return JSON.parse(decryptedData);
};

const categoryWordResult = createSlice({
  name: "categoryWordSlice",
  initialState,
  reducers: {
    setCategoryResult: (state, action) => {
      const targetWord = decryptData(action.payload.targetWord).toLowerCase();
      const enteredWord = action.payload.enteredWord.join("").toLowerCase();
      if (targetWord == enteredWord) {
        console.log("true");
        state.categoryWordResult = true;
      } else {
        console.log("false");
        state.categoryWordResult = false;
      }
      localStorage.setItem("categoryWordResult", JSON.stringify(state));
      return state;
    },
    resetCategoryResult: (state, action) => {
      state.categoryWordResult = null;
      localStorage.removeItem("categoryWordResult");
      return state;
    },
  },
});

export const { setCategoryResult, resetCategoryResult } =
  categoryWordResult.actions;
export default categoryWordResult;
